module.exports = __WEBPACK_EXTERNAL_MODULE_149__;


//////////////////
// WEBPACK FOOTER
// external "get-cursor-position"
// module id = 149
// module chunks = 0